module.exports = __webpack_public_path__ + "img/idcard_back.0665f4a2.png";